import React from "react"
import PropTypes from "prop-types"
import { CheckboxFieldBlock } from "gatsby-interface"

const propTypes = {
  id: PropTypes.string.isRequired,
  checked: PropTypes.bool,
}

export default function ToggleCheckbox({ id, ...rest }) {
  return (
    <CheckboxFieldBlock
      id={id}
      name={id}
      data-cy={id}
      labelSize="L"
      value={true}
      {...rest}
    />
  )
}

ToggleCheckbox.propTypes = propTypes
